import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { assetsAnalyticsDataViewListEntryPoint } from '@jira/spa-apps__servicedesk-cmdb-assets-custom-metrics/src/assetsAnalyticsDataViewListEntryPoint.entrypoint.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServicedeskPageContextResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { assetsAnalyticsDataViewListRoute } from '@jira/router-routes__assets-app-routes/src/assetsAnalyticsDataViewListRoute.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { toPackageName, APP_NAMES } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
import type { Route } from '@atlassian/react-resource-router';

const assetsAnalyticsDataViewListPageEntryPoint = createChromelessEntryPoint({
	main: assetsAnalyticsDataViewListEntryPoint,
});

export const assetsAnalyticsDataViewListRouteEntry: Route = createEntry(
	assetsAnalyticsDataViewListRoute,
	() => ({
		group: 'assets',
		LayoutOverrideComponent: AssetsLayout,
		PageConfigContainerOverride: AssetsPageConfigContainer,
		skeleton: AssetsSpinner,
		entryPoint: () => assetsAnalyticsDataViewListPageEntryPoint,
		pageId: () => 'spa-apps/servicedesk/insight/cmdb-assets-analytics-data-view-list-page',
		resources: [...getAssetsAppResources(), ...getServicedeskPageContextResources()],
		forPaint: [LazyAssetsLayout],
		meta: {
			reporting: {
				id: 'insight-assets-analytics-data-view-list',
				packageName: toPackageName(APP_NAMES.ASSETS_APP_ANALYTICS_DATA_VIEW_LIST_PAGE),
				teamName: 'ITSM SAGA',
			},
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
